/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S8_Li2_DescInputs */

const tr_iade_iptal_s8_li2_desc = /** @type {(inputs: Iade_Iptal_S8_Li2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesafeli Hizmet Sözleşmesi'nin veya Kullanım Koşulları'nın esaslı ihlali; Platform altyapısına yönelik sömürü, olağandışı yük veya güvenlik ihlali girişimi.`)
};

const en_iade_iptal_s8_li2_desc = /** @type {(inputs: Iade_Iptal_S8_Li2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Material breach of the Distance Service Agreement or of the Terms of Use; exploitation of the Platform infrastructure, unusual load or an attempted security breach.`)
};

const de_iade_iptal_s8_li2_desc = /** @type {(inputs: Iade_Iptal_S8_Li2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wesentlicher Verstoß gegen den Fernabsatzvertrag für Dienstleistungen oder die Nutzungsbedingungen; Ausnutzung der Plattform-Infrastruktur, außergewöhnliche Last oder Versuch einer Sicherheitsverletzung.`)
};

const ru_iade_iptal_s8_li2_desc = /** @type {(inputs: Iade_Iptal_S8_Li2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Существенное нарушение Дистанционного договора оказания услуг или Условий использования; эксплуатация инфраструктуры Платформы, необычная нагрузка или попытка нарушения безопасности.`)
};

/**
* | output |
* | --- |
* | "Material breach of the Distance Service Agreement or of the Terms of Use; exploitation of the Platform infrastructure, unusual load or an attempted security ..." |
*
* @param {Iade_Iptal_S8_Li2_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s8_li2_desc = /** @type {((inputs?: Iade_Iptal_S8_Li2_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S8_Li2_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s8_li2_desc(inputs)
	if (locale === "de") return de_iade_iptal_s8_li2_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s8_li2_desc(inputs)
	return tr_iade_iptal_s8_li2_desc(inputs)
});